<template>
  <div
    v-if="items.length"
    id="medals"
    class="lpu-medals d-flex flex-column ga-3"
    :class="isMobile ? 'lpu-medals--mobile' : 'lpu-medals--desktop'"
    data-qa="lpu_medals"
  >
    <h2
      class="text-subtitle-1 text--text"
      data-qa="lpu_medals_title"
    >
      {{ tStatic('Медали') }}
    </h2>

    <CoreSwiper
      class="lpu-medals__swiper"
      slides-per-view="auto"
      :space-between="12"
      :has-pagination="false"
      :has-navigation="!isMobile"
      free-mode
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="(item, index) in items"
          :key="item.id"
          v-bind="slideAttrs"
        >
          <LpuMedalCard
            :src="item.src"
            :alt="item.alt"
            :href="item.href"
            :count="item.count"
            :use-hover="!isMobile"
            @open="openedIndex = index"
          />
        </div>
      </template>
    </CoreSwiper>

    <LpuMedalDialog
      :value="openedIndex !== null"
      :items="items"
      :initial-slide="openedIndex ?? 0"
      @input="onDialogInput"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import LpuMedalCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuMedals/components/LpuMedalCard.vue'
import LpuMedalDialog from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuMedals/components/LpuMedalDialog.vue'
import mapLpuMedals from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuMedals/functions/mapLpuMedals'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

const props = defineProps<{
  lpu: Lpu
}>()

const isMobile = useIsMobile()
const items = computed(() => mapLpuMedals(props.lpu))
const openedIndex = ref<number | null>(null)

function onDialogInput(isOpened: boolean) {
  if (!isOpened) {
    openedIndex.value = null
  }
}
</script>

<style scoped lang="scss">
@import 'www/themes/doctors/common/variables';

.lpu-medals {
  min-width: 0;
  overflow: clip visible;

  // Небольшой запас под тень и left: -3px;
  &--desktop {
    padding: 3px 3px 0;
  }

  &--mobile {
    padding: 0 8px;
    margin: 0 -8px;
  }

  &__swiper {
    min-width: 0;
    min-height: 148px;
    overflow: visible;

    :deep(.core-swiper) {
      min-height: 148px;
      overflow: visible;
    }

    :deep(.swiper-container),
    :deep(.swiper-wrapper),
    :deep(.swiper-slide) {
      overflow: visible;
    }

    :deep(.core-swiper:not(.core-swiper--ready) > .swiper-container) {
      min-height: 148px;
      height: 148px;
      visibility: hidden;
      overflow: hidden;
    }

    :deep(.swiper-button-prev),
    :deep(.swiper-button-next) {
      background-color: var(--lpu-branding-color-primary, $ui-kit-primary) !important;
      color: $ui-kit-bg-gray-0 !important;
    }

    // Скрыта, но ловит клики: иначе промах по пропавшей стрелке открывает медаль
    :deep(.swiper-button-disabled) {
      opacity: 0 !important;
      pointer-events: auto !important;
      cursor: default;
    }
  }
}
</style>
